var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/DionWebEnvService.ts
var DionWebEnvService = class {
  constructor() {
    __publicField(this, "env", null);
    __publicField(this, "envSource", /* @__PURE__ */ new Map());
  }
  init(apiUrl) {
    return __async(this, null, function* () {
      try {
        const envFromLocalStorage = localStorage.getItem(apiUrl);
        if (envFromLocalStorage !== null) {
          this.setAll(JSON.parse(envFromLocalStorage));
        } else {
          let env = {};
          if (this.envSource.has(apiUrl)) {
            env = this.envSource.get(apiUrl);
          } else {
            const response = yield fetch(apiUrl);
            env = yield response.json();
            this.envSource.set(apiUrl, env);
          }
          this.setAll(env);
        }
        return true;
      } catch (e) {
        return false;
      }
    });
  }
  get(envKey) {
    return this.env ? this.env[envKey] : null;
  }
  getAll() {
    return this.env;
  }
  setAll(env) {
    this.env = __spreadValues(__spreadValues({}, this.env), env);
  }
};
var dionWebEnvService = new DionWebEnvService();

// src/DionWebEnvServiceWrapper/DionEnvServiceWrapper.tsx
import { Suspense, useEffect, useState } from "react";
import { jsx } from "react/jsx-runtime";
var DionEnvServiceWrapper = ({ lazyChildrenProps, lazyChildren: LazyChildren, url, loadingIndicator }) => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    dionWebEnvService.init(url).then(() => {
      setLoaded(true);
    });
  }, []);
  if (!loaded) {
    return loadingIndicator;
  }
  return /* @__PURE__ */ jsx(Suspense, { fallback: loadingIndicator, children: /* @__PURE__ */ jsx(LazyChildren, __spreadValues({}, lazyChildrenProps)) });
};
export {
  DionEnvServiceWrapper,
  dionWebEnvService
};
